/* Polyfill
 ---------------------------------------------------------- */
import './polyfill/_assign'
import './polyfill/_entries'
import './polyfill/_isnan'
import './polyfill/_repeat'
import './polyfill/_for-each'

/* Modules
 ---------------------------------------------------------- */
import Navigation from './modules/_navigation'
import ObjectFit from './modules/_object-fit'
import Print from './modules/_print'
import VideoModal from './modules/_video-modal'
import CoverSliders from './modules/_cover-sliders'
import ReviewSlider from './modules/_review-slider'
import CitySelect from './modules/_city-select'
import Search from './modules/_search'
import { EmployeeSlider, TextImageEmployeeSlider } from './modules/_employee-slider'
import FloatingLabels from './modules/_floating-labels'
import DatePicker from './modules/_date-picker'
import Modals from './modules/_modal'
import LinkSlider from './modules/_link-slider'
import TableOfContents from './modules/_table-of-contents'
import Accordion from './modules/_accordion'
import PriceSlider from './modules/_price-slider'
import SmoothScroll from './modules/_smooth-scroll'
import News from './modules/_news'
import StickyPolyfill from './modules/_sticky'
import ImageCardsLightbox from 'modules/_image-cards-lightbox'

/* Register modules
 ---------------------------------------------------------- */
Navigation()
ObjectFit()
Print()
VideoModal()
CoverSliders()
ReviewSlider()
CitySelect()
Search()
EmployeeSlider()
TextImageEmployeeSlider()
FloatingLabels()
DatePicker()
Modals()
LinkSlider()
new TableOfContents()
Accordion()
PriceSlider()
new SmoothScroll()
News()
StickyPolyfill()
ImageCardsLightbox()
